export default __webpack_public_path__ + "static/7_18-a4f2c274004a41f16cf5aa42fdc14d24.png";